import { Home, ArrowRight } from "lucide-react";

export function EmptyState() {
  return (
    <div className="flex flex-col items-center justify-center py-24 px-6 text-center animate-in fade-in duration-500">
      {/* Decorative icon */}
      <div className="relative mb-8">
        <div className="w-20 h-20 rounded-2xl bg-primary/5 border border-primary/10 flex items-center justify-center rotate-3">
          <Home className="w-8 h-8 text-primary/40" />
        </div>
        <div className="absolute -bottom-2 -right-2 w-6 h-6 rounded-lg bg-primary/10 border border-primary/15 -rotate-6" />
      </div>

      <h2 className="font-display text-2xl font-semibold text-foreground mb-3">
        Inga sparade bostäder
      </h2>
      <p className="text-muted-foreground text-sm max-w-sm leading-relaxed mb-6">
        Klistra in en länk från Hemnet ovan för att börja samla dina favoritbostäder.
        Vi sparar bilder och all information lokalt.
      </p>

      <div className="flex items-center gap-2 text-xs text-muted-foreground/60">
        <span>Klistra in en länk</span>
        <ArrowRight className="w-3 h-3" />
        <span>Vi hämtar data</span>
        <ArrowRight className="w-3 h-3" />
        <span>Sparas lokalt</span>
      </div>
    </div>
  );
}
